import commonFn from '@/commons/commonFunction';
import voucherAPI from '@/apis/lg/voucherAPI.js';
import FixValue from '@/commons/wildcards/constants/FixValue.js';

import _ from 'lodash';
export default class {
  constructor(name, api) {
    const me = this;
    /**
     * state
     */
    me.state = {
      /**
       * Cấu hình của module
       */
      _config: {
        field: {}
      },
      /**
       * loading
       */
      loading: false,
      /**
       * loading load summary
       */
      loadingSummary: false,
      /**
       * Tổng bản ghi theo paging
       */
      total: 0,
      /**
       * Thông tin tổng
       */
      summary: null,
      /**
       * active data - dùng cho combobox
       */
      items: [],
      /**
       * Không có dữ liệu trong bảng
       * Dùng cờ này để hiển thị mặc hình trống trên danh sách
       */
      empty: false,
      /**
       * Danh sách các cache key sẽ phải xóa đi khi có cập nhật dữ liệu
       */
      cacheKeys: [],

      /**
       * Dòng dữ liệu đang active
       */
      active: null,

      /**
       * Version dữ liệu ở client để đánh dấu là có thay đổi -> dựa theo món này thay đổi để load lại dữ liệu của combobox
       */
      version: 1,

      /**
       * Tham số lấy dữ liệu
       */
      payload: null,

      /**
       * Tham số lấy dữ liệu next back
       */
      payloadNextBack: null,

      /**
       * Tất cả id theo filter
       */
      allIds: []
    };

    /**
     * actions
     */
    me.actions = {
      /**
       * Lấy đường dẫn controller api
       */
      getController() {
        return api.getAPIUrl();
      },
      /**
       * Load danh sách
       */
      async load(context, payload) {
        let res = null;
        try {
          context.commit('updateLoading', true);
          res = await api.getList(payload || {});
        } finally {
          context.commit('updateLoading', false);
        }

        context.commit('updatePayloadNextBack', { ...payload });
        if (res && !payload.isNextBack) {
          context.commit('setPaging', res);
        }

        return res;
      },
      /**
       * Load danh sách
       */
      async loadSummary(context, payload) {
        let res = null;
        try {
          context.commit('updateLoadingSummary', true);
          res = await api.getList(payload || {});
        } finally {
          context.commit('updateLoadingSummary', false);
        }

        if (res) {
          context.commit('setPaging', res);
          context.commit('setPayload', payload);
        }

        return res;
      },
      /**
       * Load tree
       */
      async loadTree(context, payload) {
        let res = null;

        try {
          context.commit('updateLoading', true);
          res = await api.getTree(payload || {});
        } finally {
          context.commit('updateLoading', false);
        }

        if (res) {
          context.commit('setItems', res);
        }

        return res;
      },
      /**
       * Load full data
       */
      async getFullList(context, payload) {
        context.commit('updateLoading', true);

        let res = await api.getFullList(payload || {});
        context.commit('updateLoading', false);

        if (res) {
          context.commit('setItems', res);
        }

        return res;
      },
      /**
       * Lấy tất cả id theo filter
       */
      async getListId(context, payload) {
        let res = await api.getListId(payload || {});

        return res;
      },
      /**
       * Lấy dl theo cột và filter truyển vào
       */
      async GetColumnsWithFilters(context, payload) {
        let res = await api.GetColumnsWithFilters(payload || {});

        return res;
      },
      /**
       * Lấy danh sách dữ liệu theo id
       */
      async getDataByIds(context, payload) {
        return await api.getDataByIds(payload || {});
      },
      /**
       * clearItem
       * @param {*} context
       */
      clearItem(context) {
        context.commit('setItems', []);
      },
      /**
       * Lấy mã tự tăng
       */ async getAutoID(context, payload) {
        //context.commit("updateLoading", true);

        let res = await api.getAutoID(payload);
        //context.commit("updateLoading", false);

        return res;
      },
      /**
       * Load dữ liệu để thêm/sửa/nhân bản
       * Hàm này sẽ không commit mà return value để binding cho form
       */
      async get(context, payload) {
        let method = 'get' + payload.action;
        delete payload.action;

        let res = await api[method](payload);
        return res;
      },
      /**
       * Thêm mới
       */ async insert(context, payload) {
        let res = await api.insert(payload);
        if (res) {
          //cập nhật danh sách
          context.commit('insertItem', res);
        }
        return res;
      },
      /**
       * Cập nhật
       */ async update(context, payload) {
        let res = await api.update(payload);
        if (res) {
          //cập nhật danh sách
          context.commit('updateItem', res);
        }
        return res;
      },
      /**
       * Xóa
       * NVTOAN2 02/08/2022 cập nhật lại cách lấy list deleted
       */
      async delete(context, payload) {
        let res = await api.delete(payload);
        let errValidate = ['VALIDATE', 'Business', 'Exception', 'VALIDATE_DICTIONARY'];
        let keyField = context.state._config.field.key;

        //Danh sách gửi lên xóa
        let deleted = [...payload.Models];
        if (keyField && res) {
          for (let i = 0; i < res.length; i++) {
            // Nếu không xóa được thì loại bỏ khỏi list xóa
            if (errValidate.find(x => x === res[i]?.Code)) {
              if (res[i] && res[i].Data && res[i].Data.Data) {
                let itemError = payload.Models[res[i].Index];
                //Loại đi những bản ghi không xóa được
                deleted = deleted.filter((item, index) => {
                  return !(item[keyField] === res[i].Data.Data[keyField] || item[keyField] === itemError[keyField]);
                });
              }
            }
          }
        }

        //Commit thực hiện xóasinp
        context.commit('deleteItems', deleted);
        return res;
      },
      /**
       * Xóa dữ liệu (chứng từ liên quan)
       * @param {*} context
       * @param {*} payload
       * NXCHIEN 17.07.2022
       */
      async deleteRelation(context, payload) {
        return await api.deleteRelation(payload);
      },
      /**
       * Insert vào state trường hợp có nhiều master trên 1 danh sách
       * NXCHIEN 11.08.2022
       */
      insertItemMultiMaster(context, res) {
        context.commit('insertItem', res);
      },
      /**
       * update vào state trường hợp có nhiều master trên 1 danh sách
       * NXCHIEN 11.08.2022
       */ updateItemMultiMaster(context, res) {
        context.commit('updateItem', res);
      },
      /**
       * update vào state ghi sổ trường hợp có nhiều master trên 1 danh sách
       * NNLINH 24.08.2022
       */ postedItemMultiMaster(context, res) {
        let param = { data: [res.data], value: true };
        context.commit('updateItemPosted', param);
      },
      /**
       * update vào state ghi sổ trường hợp có nhiều master trên 1 danh sách
       * NNLINH 24.08.2022
       */ unPostedItemMultiMaster(context, res) {
        let param = { data: [res.data], value: false };
        context.commit('updateItemPosted', param);
      },
      /**
       * delete vào state trường hợp có nhiều master trên 1 danh sách (xóa 1 bản ghi trong detail)
       * NXCHIEN 11.08.2022
       */ deleteItemMultiMaster(context, payload) {
        let errValidate = ['VALIDATE', 'Business', 'Exception'];
        let keyField = context.state._config.field.key;

        //Danh sách gửi lên xóa
        let deleted = [payload];
        let res = payload.result;
        if (keyField && res) {
          for (let i = 0; i < res.length; i++) {
            // Nếu không xóa được thì loại bỏ khỏi list xóa
            if (errValidate.find(x => x === res[i]?.Code)) {
              if (res[i] && res[i].Data && res[i].Data.Data) {
                let itemError = payload.Models[res[i].Index];
                //Loại đi những bản ghi không xóa được
                deleted = deleted.filter((item, index) => {
                  return !(item[keyField] === res[i].Data.Data[keyField] || item[keyField] === itemError[keyField]);
                });
              }
            }
          }
        }

        //Commit thực hiện xóa
        context.commit('deleteItems', deleted);
      },
      /**
       * Cập nhật danh sách bên ngoài sau khi xóa bản ghi liên quan bên trong màn hình chi tiết
       * @param {*} context
       * @param {*} payload
       * @returns
       * NVTUAN1 26.07.2022
       */
      updateAfterDeleteRelation(context, payload) {
        let keyField = context.state._config.field.key;

        if (keyField) {
          let deleted = [];
          if (payload && Array.isArray(payload) && payload.length) {
            for (let i = 0; i < payload.length; i++) {
              let obj = {};
              obj[keyField] = payload[i].RefId;

              deleted.push(obj);
            }
          }
          context.commit('deleteItems', deleted);
        }
      },
      /**
       * update trạng thái theo dõi/ngưng theo dõi
       * NXCHIEN 26.04.2022
       */ async followState(context, param) {
        let res = await api.quickUpdateFollowState(param || {});
        if (res) {
          //cập nhật danh sách
          let payload = { data: res, value: param.Value };
          context.commit('updateItemQuickFllow', payload);
        }
        return res;
      },
      /**
       * update trạng thái đã lập hồ sơ, chưa lập hồ sơ
       * nmtuan4 27.4.2023
       */
      async updateIsDvcVOucher(context, param) {
        let res = await api.updateIsDvcVoucher(param || {});
        if (res) {
          //cập nhật danh sách
        }
        return res;
      },
      /**
       * lấy dữ liệu chi tiết chứng từ từ master
       * NTLOC 09.06.2023
       */
      async getListDetail(context, payload) {
        let res = await api.getListDetail(payload);
        return res;
      },
      /**
       * Ghi sổ
       * NXCHIEN 26.06.2022
       */ async posted(context, payload) {
        let res = await voucherAPI.posted(payload);
        if (res.is_success == true) {
          let param = { data: [payload.data], value: true };
          //cập nhật danh sách
          context.commit('updateItemPosted', param);
        }
        return res;
      },
      /**
       * Sửa nhanh chứng từ
       * lhphong 29.05.2023
       */ async quickEditVoucher(context, payload) {
        let res = await voucherAPI.quickEditVoucher(payload);
        if (res.is_success == true) {
          let param = { data: [payload.data], value: true };
          //cập nhật danh sách
          context.commit('updateItemPosted', param);
        }
        return res;
      },

      /**
       * Bỏ Ghi sổ
       * NXCHIEN 26.06.2022
       */ async unPosted(context, payload) {
        let res = await voucherAPI.unPosted(payload);
        if (res.is_success == true) {
          let param = { data: [payload.data], value: false };
          //cập nhật danh sách
          context.commit('updateItemPosted', param);
        }
        return res;
      },
      /**
       * Cập nhật trạng thái ngừng theo dõi của các bản ghi
       * @param {*} context
       * @param {*} payload
       * tbngoc 08.07.2022
       */ updateItemQuickFollow(context, payload) {
        context.commit('updateItemQuickFllow', payload);
      },
      /**
       * Ghi sổ theo lô
       * NNLINH 08.07.2022
       */ async postBatch(context, payload) {
        let res = await voucherAPI.postBatch(payload);
        if (res.length != 0) {
          let arrayRefIdError = [];
          res.forEach(e => {
            arrayRefIdError.push(e.DataBusinessException.Data[0].ref_id);
          });
          payload.data = payload.data.filter(x => x.refId != arrayRefIdError.find(e => e == x.refId));
          let param = { data: payload.data, value: true };
          context.commit('updateItemPosted', param);
        } else {
          let param = { data: payload.data, value: true };
          //cập nhật danh sách
          context.commit('updateItemPosted', param);
        }
        return res;
      },
      /**
       * Bỏ ghi sổ theo lô
       * NNLINH 08.07.2022
       */ async unPostBatch(context, payload) {
        let res = await voucherAPI.unPostBatch(payload);
        if (res.length != 0) {
          let arrayRefIdError = [];
          res.forEach(e => {
            if (e.DataBusinessException.Code == "UnPost_ErrorUnPostExistInGLVoucherList") {
              arrayRefIdError.push(e.DataBusinessException.Data[0].ref_id_voucher);
            }
            else {
              arrayRefIdError.push(e.DataBusinessException.Data[0].ref_id);
            }
          });
          payload.data = payload.data.filter(x => x.refId != arrayRefIdError.find(e => e == x.refId));
          let param = { data: payload.data, value: false };
          context.commit('updateItemPosted', param);
        } else {
          let param = { data: payload.data, value: false };
          //cập nhật danh sách
          context.commit('updateItemPosted', param);
        }
        return res;
      },
      /* Cập nhật dữ liệu khi chuyển danh mục
       * nthien4 08.07.2022
       */ async updateTranferData(
        context,
        payload
      ) {
        let res = await api.UpdateTranferData(payload || {});
        if (res) {
          if (payload.State == 0) {
            context.commit('insertItem', payload.ToData);
          } else if (payload.State == 1) {
            context.commit('updateItem', payload.ToData);
          }
        }
        return res;
      },

      /**
       * Cập nhật dữ liệu đang active
       * @author nnnam - 13/9/2022s
       */
      setActive(context, item) {
        context.commit('updateActive', item);
      },

      /**
       * Load danh sách combo header
       */
      // async loadComboboxHeader(context, payload) {
      //   return await api.getList(payload || {});
      // },
      async loadComboboxHeader(context, payload) {
        return await api.getHeaderComboboxList(payload || {});
      },
    };

    /**
     * mutations
     */
    let defaultState = {};
    Object.assign(defaultState, me.state);
    me.mutations = {
      updatePayloadNextBack(state, payload) {
        state.payloadNextBack = payload;
      },
      resetState(state) {
        Object.assign(state, defaultState);
      },
      setItems(state, data) {
        state.items = data;
      },
      setAllIds(state, data) {
        state.allIds = data;
      },
      setPayload(state, payload) {
        state.payload = payload;
      },
      // nvtoan2 20/11/2023: Gán payload lấy dữ liệu màn ngoài phục vụ next back
      setPayloadNextBack(state, payload) {
        state.payloadNextBack = payload;
      },
      setPaging(state, data) {
        if (data) {
          for (let i in data) {
            let resultValue = data[i];
            switch (i) {
              case 'PageData':
                state.items = resultValue;
                break;
              case 'Total':
                state.total = resultValue;
                break;
              case 'Empty':
                state.empty = resultValue;
                break;
              case 'SummaryData': {
                state.summary = resultValue;
                break;
              }
            }
          }
        }
      },
      addNew(state, item) {
        state.items.push(item);
      },
      updateLoading(state, data) {
        state.loading = data;
      },
      updateLoadingSummary(state, data) {
        state.loadingSummary = data;
      },
      setItem(state, data) {
        state.item = data;
      },
      /**
       * Cập nhật khi thêm bản ghi
       */ insertItem(state, data) {
        let newItem = data;
        state.items = _.concat(newItem, state.items);
        state.total += 1;
        state.empty = false;

        //xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys);
        }
        state.version++;
      },

      /**
       * Cập nhật khi thêm list bản ghi phần tài sản cố định
       * NTLOC 20.09.2022
       */
      insertListItem(state, data) {
        let newItem = data;
        state.items = _.concat(newItem, state.items);
        state.total += data.length;
        state.empty = false;

        //xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys);
        }
        state.version++;
      },

      /**
       * Cập nhật khi sửa bản ghi
       */
      updateItem(state, data) {
        let keyField = state._config.field.key;
        if (keyField) {
          let id = data[keyField];
          for (let i = 0; i < state.items.length; i++) {
            let item = state.items[i];

            if (item[keyField] === id) {
              //NCPHUOC 08/07/2022: Check xem nếu có thay đổi ở cấu trúc tree thì thì assign lại data để thực hiện build lại cấu trúc
              //NVTUAN1 11.04.2024: Thay đổi cách check để không bị ảnh hưởng bởi PBI 419812 (fix bug 438690)
              if ((item.hasOwnProperty('parent_id') || data.hasOwnProperty('parent_id')) && item['parent_id'] != data['parent_id']) {

                //NVTUAN1 12.04.2024
                //Cập nhật giá trị null cho các property thằng cũ có mà thằng mới không có để không bị lỗi màn danh sách vẫn hiển thị giá trị cũ sau khi sửa
                //Một số property mặc định để sử dụng ngoài màn danh sách tree thì không cập nhật để giữ nguyên logic code từ đầu
                for (const key in item) {
                  if (!(key in data) && !FixValue.ListPropertyTreeDefault.includes(key)) {
                    item[key] = null;
                  }
                }

                Object.assign(item, data);
                state.items = [...state.items];
              } else {
                Object.assign(item, data);
              }
              break;
            }
          }
        }

        //xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys);
        }
        state.version++;
      },
      /**
       * Cập nhật khi sửa bản ghi
       * NXCHIEN 07.06.2022
       */
      updateItemQuickFllow(state, payload) {
        let quickField = state._config.field.quickFollow,
          keyField = state._config.field.key,
          data = payload.data,
          value = payload.value;

        if (data && data.length) {
          for (let i = 0; i < data.length; i++) {
            if (keyField && quickField) {
              let id = data[i];
              let objValue = {};
              objValue[quickField] = value;

              for (let j = 0; j < state.items.length; j++) {
                let item = state.items[j];

                if (item[keyField] === id) {
                  Object.assign(item, objValue);
                  // break;
                }
              }
            }
          }
        }

        //xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys);
        }
        state.version++;
      },
      /**
       * Cập nhật khi sửa bản ghi ghi sổ
       * NNLINH 15.07.2022
       */
      updateItemPosted(state, payload) {
        let postedField = state._config.field.posted,
          keyField = state._config.field.key,
          data = payload.data,
          value = payload.value;
        if (data && data.length) {
          for (let i = 0; i < data.length; i++) {
            if (keyField && postedField) {
              let id = data[i];
              let objValue = {};
              objValue[postedField] = value;

              for (let j = 0; j < state.items.length; j++) {
                let item = state.items[j];

                if (item[keyField] === id?.refId) {
                  Object.assign(item, objValue);
                  // break;
                }
              }
            }
          }
        }

        //xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys);
        }
        state.version++;
      },

      /**
       * Cập nhật khi xóa bản ghi
       */
      deleteItems(state, items) {
        let keyField = state._config.field.key;

        if (keyField) {
          let count = items.length;
          let newList = [];
          for (let i = 0; i < state.items.length; i++) {
            let item = state.items[i],
              ignore = false;
            for (let k = 0; k < count; k++) {
              let id = items[k][keyField];

              if (item[keyField] === id) {
                ignore = true;
                break;
              }
            }

            if (!ignore) {
              newList.push(item);
            }
          }

          state.items = newList;
          state.total -= count;
        }

        //xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys);
        }
        state.version++;
      },

      /**
       * Cập nhật dữ liệu đang active
       */
      updateActive(state, item) {
        state.active = item;
      }
    };

    /**
     * getters
     */
    me.getters = {};
    for (let i in me.state) {
      me.getters[i] = function (state) {
        return state[i];
      };
    }
  }
}
